import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axios'
import { VPopover } from 'v-tooltip'
import { mapGetters } from 'vuex'
import VCalendar from 'v-calendar'
Vue.component('v-popover', VPopover)
Vue.use(VCalendar)
Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  created () {
    if (this.getToken) {
      axios.defaults.headers.Authorization = `Bearer ${this.getToken}`
    }
  },
  computed: {
    ...mapGetters(['getToken'])
  },
  watch: {
    getToken (val) {
      axios.defaults.headers.Authorization = `Bearer ${val}`
    }
  },
  render: h => h(App)
}).$mount('#app')
